import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseSettingService } from 'src/app/services/enterprise-setting/enterprise-setting.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { MessageModalComponent } from '../../message/message-modal.component';

@Component({
  selector: 'app-enterprise-setting-modal',
  templateUrl: './enterprise-setting-modal.component.html',
  styleUrls: ['./enterprise-setting-modal.component.css']
})
export class EnterpriseSettingModalComponent implements OnInit {
  settingForm: FormGroup
  title: string;
  loading: boolean = false;
  isAdminGys: boolean = false;
  sessionUserId: string;
  storageFileSelect: number;
  logo = "../../../../../../assets/images/enterprise-default.png";
  fileLogo: File;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private enterpriseSettingService: EnterpriseSettingService,
    private alertService: AlertService,
    private emitterService: EmitterService) { }

  ngOnInit() {
    this.title = this.data.title;
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.sessionUserId = localStorage.getItem(AppConstants.Session.USERID);
    this.createForm();
    this.getData();
  }

  getData() {
    this.spinner.show();
    this.enterpriseSettingService.getEnterpriseSetting(this.data.row.id).subscribe((response => {
      if(response.error == null && response.enterpriseSetting != null){
        this.settingForm.patchValue({
          idEnterprise: this.data.row.id,
          color1: response.enterpriseSetting.color1,
          color2: response.enterpriseSetting.color2,
          /*idStorageFile: response.enterpriseSetting.idStorageFile,
          pathFile: response.enterpriseSetting.pathFile,*/
          userId: parseInt(this.sessionUserId)
        });
        if(response.enterpriseSetting.logo != "" && response.enterpriseSetting.logo){
          if(response.enterpriseSetting.idStorageType == 2){//azure
            this.logo = response.enterpriseSetting.logo;
          }else{
            // this.logo = response.enterpriseSetting.storagePath + 
            this.logo = "assets/"+response.enterpriseSetting.logo;
          }
        }
      }
      this.spinner.hide();
    }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  createForm() {
    this.settingForm = this.formBuilder.group({
        idEnterprise: this.data.row.id,
        color1: [true, [Validators.required]],
        color2: [true, [Validators.required]],
        /*idStorageFile: [[Validators.required]],
        pathFile: [],*/
        userId: parseInt(this.sessionUserId)
    });
  }

  get f() { return this.settingForm.controls; }

  openConfirmationModal() {
    if (this.settingForm.valid) {
      let dialogRef = this.dialog.open(MessageModalComponent, {
          data: {
              title: AppConstants.TitleModal.ENTERPRISE_SETTING_UPDATE,
              message: AppConstants.MessageModal.UPDATE_MESSAGE_ENTERPRISE_SETTING_CONFIRM,
              hasButton: true,
              contentButton: {
                  yes: 'SI',
                  no: 'CANCELAR'
              }
          },
      });

      dialogRef.afterClosed().subscribe(response => {
          if (response.result == true) {
            this.update();
          }
      });

    } else {
      this.settingForm.markAllAsTouched();
    }
  }

  update() {
    /*if(this.settingForm.get('idStorageFile').value == 1 && !this.settingForm.get('pathFile').value){
      this.alertService.showMessage("", AppConstants.MessageModal.REQUIRED_ENTERPRISE_SETTING_PATH_FILE, MessageSeverity.error);
      return false;
    }*/

    if(this.settingForm.valid){
      this.spinner.show();

      var formData = new FormData();
      formData.append("color1",this.settingForm.value["color1"]);
      formData.append("color2",this.settingForm.value["color2"]);
      formData.append("userId",this.sessionUserId);
      formData.append("idEnterprise",this.data.row.id);
      formData.append("logo",this.fileLogo);

      this.enterpriseSettingService.updateEnterpriseSetting(formData).subscribe((response => {
        this.alertService.showMessage("", AppConstants.MessageModal.UPDATE_ENTERPRISE_SETTING, MessageSeverity.success);
        this.spinner.hide();
        this.close();
      }),
        (error: HttpErrorResponse) => {
          this.alertService.showMessage("", error.error.messages, MessageSeverity.error);
          this.spinner.hide();
        });
    }else{
      this.settingForm.markAllAsTouched();
      this.alertService.showMessage("", AppConstants.MessageModal, MessageSeverity.error);
    }
  }

  close() {
    this.dialog.closeAll();
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var _this = this;
      reader.onload = (event:any) => {
        _this.logo = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
      this.fileLogo = event.target.files[0];
  }
  }
}
